import _ from "lodash"
import { Autocomplete, CircularProgress, IconButton, TextField } from "@mui/material";
import { useCallback, useEffect, useMemo, useState } from "react";
import SearchIcon from "@mui/icons-material/Search";
import InputBox from "../input/InputBox";
import { PField } from "../input/NestedField";
import { fetchArray } from "entity";
import EntitySearchDialog from "./EntitySearchDialog";
import { fieldHasError, requiredValidator } from "../input/validator";

export default function EntitySearchInput({
    name,
    label,
    required,
    helperText,
    EntityClass,
    initialValue,
    optionLabelField,
    extraQuery,
    onChange,
    onlyIcon,
    sx,
    specificColumns,
    addFields,
    stringFieldOrderBy,
    ...props
}) {
    const [options, setOptions] = useState([]);
    const [open, setOpen] = useState(false);
    const loading = open && options.length === 0;

    const [searchDialog, setSearchDialog] = useState();

    const labelField = optionLabelField || EntityClass.labelField;
    const realExtraQuery = useMemo(() => extraQuery, [extraQuery]);
    useEffect(() => {
        // console.log('realExtraQuery', realExtraQuery)
        setOptions([]);
        return () => { }
    }, [realExtraQuery])

    const loadOptions = useCallback(async () => {
        // Carrega apenas uma vez.
        if (options.length === 0) {
            // console.log('load')
            let query = await EntityClass.query();
            // let query = await EntityClass.where(labelField, "!=", "");

            if (realExtraQuery) {
                query = realExtraQuery(query);
            }

            let result = await fetchArray(query.get());

            // console.log("resultTTT", result)
            // console.log(`${_.get(result[0], EntityClass.labelField)}`)
            // ${_.get(result[0], addColumnsAutocomplete[0])}
            // console.log("addColumnsAutocomplete", addColumnsAutocomplete)
            // if (addColumnsAutocomplete?.length) {
            //     // console.log(`${_.get(result[0], addColumnsAutocomplete[0])}`)
            //     // console.log(`${_.get(result[0], EntityClass.labelField)} - ${_.get(result[0], addColumnsAutocomplete[0])}`)
            //     for (let i = 0; i < addColumnsAutocomplete.length; i++) {
            //         // console.log(result.map(r => `${_.get(r, EntityClass.labelField)} - ${_.get(r, addColumnsAutocomplete[i])}`))
            //         result = result.map(r =>
            //             // _.set(obj, columns[i].field, toUpper)
            //             _.set(
            //                 r,
            //                 EntityClass.labelField,
            //                 `${_.get(r, EntityClass.labelField)} - ${_.get(r, addColumnsAutocomplete[i])}`
            //             )
            //         )
            //         // console.log(`${_.get(result[0], EntityClass.labelField)} - ${_.get(result[0], addColumnsAutocomplete[0])}`)
            //     }
            // }
            // columns.map((column) => {
            //     if (column.filter) {



            //         let v = _.get(values, column.field)
            //         if (v) {
            //             newFilters[column.field] = { value: v };
            //         }

            //     }
            // })

            // let auxMap = result.map((r) => {
            //     let upperCased = {};
            //     for (var key in r) {
            //         if (typeof r[key] === "string"
            //             && key !== "uid"
            //             && key !== "userLastChange") {
            //             upperCased[key] = r[key].toUpperCase()
            //         } else {
            //             upperCased[key] = r[key]
            //         }
            //     }
            //     return upperCased
            // })
            // console.log("auxMap", auxMap)

            // console.log("result", result)
            if (stringFieldOrderBy) {
                result.sort((a, b) => _.get(result, `${a}.${stringFieldOrderBy}`)?.localeCompare(_.get(result, `${b}.${stringFieldOrderBy}`)))
            }

            setOptions(["", ...result]);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [options.length, EntityClass, realExtraQuery, addFields]);

    useEffect(() => {
        // Carrega ao abrir auto complete.
        if (open) {
            loadOptions();
        }
    }, [loadOptions, open]);

    function openSearchDialog() {
        loadOptions();
        searchDialog.setOpen(true);
    }

    return (
        <InputBox sx={sx}>
            <PField
                name={name}
                initialValue={initialValue}
                validate={required ? requiredValidator : null}
                onChange={onChange}
            >
                {(fieldProps) => {
                    const hasError = fieldHasError(fieldProps.meta);
                    return (
                        <>
                            <Autocomplete
                                options={options}
                                getOptionLabel={(option) => option
                                    ? _.get(option, labelField)
                                        ? (_.get(option, labelField) + (addFields
                                            ? addFields.map(f => _.get(option, f)
                                                ? " - " + _.get(option, f)
                                                : "")
                                            : ""))
                                        : ""
                                    : ""
                                }
                                // getOptionLabel={(option) =>
                                //     {
                                //     // getOptionLabel={(option) => option ? (_.get(option, labelField) + (addFields ? addFields.map(f => " - " + _.get(option, f)) : "")) : ""} 
                                //     if (option) {
                                //         let aux = _.get(option, labelField)

                                //         if (addFields) {
                                //             aux += addFields.map(f => {
                                //                 let auxF = _.get(option, f)
                                //                 if (auxF) {
                                //                     return " - " + auxF
                                //                 }
                                //                 return ""
                                //             }).join("")
                                //         }

                                //         return aux
                                //     }
                                //     return ''
                                // }}
                                isOptionEqualToValue={(option, value) => option.uid === value.uid}
                                // getOptionSelected={(option, value) => option.uid === value.uid}
                                //
                                renderOption={(props, option) =>
                                    option.uid && _.get(option, labelField) ? (
                                        <li {...props} key={option.uid}>
                                            {_.get(option, labelField)}{addFields && addFields.map(f => " - " + _.get(option, f))}
                                        </li>
                                    ) : null
                                }
                                //
                                open={open}
                                onOpen={() => setOpen(true)}
                                onClose={() => setOpen(false)}
                                loading={loading}
                                //
                                sx={{ flex: 1 }}
                                forcePopupIcon={false}
                                renderInput={(params) => (
                                    <TextField
                                        label={label}
                                        required={required}
                                        error={hasError}
                                        helperText={hasError ? fieldProps.meta.error : helperText}
                                        variant="standard"
                                        {...params}
                                        inputProps={{
                                            ...params.inputProps,
                                            style: { textTransform: "uppercase" }
                                        }}
                                        InputProps={{
                                            ...params.InputProps,
                                            endAdornment: (
                                                <>
                                                    {loading ? <CircularProgress color="inherit" size={20} /> : null}
                                                    <IconButton onClick={openSearchDialog} disabled={props.disabled} sx={{ p: "2px" }}>
                                                        <SearchIcon />
                                                    </IconButton>
                                                    {params.InputProps.endAdornment}
                                                </>
                                            ),
                                        }}
                                    />
                                )}
                                //
                                {...fieldProps.input}
                                {...props}
                                onChange={(event, value) => {
                                    // Necessário para passar os valores do MUI para o Final Form imediatamente.
                                    fieldProps.input.onChange(value);
                                }}
                            />

                            <EntitySearchDialog
                                title={label}
                                columns={specificColumns ? specificColumns : EntityClass.searchColumns}
                                data={options}
                                setDialog={setSearchDialog}
                                onClose={(value) => {
                                    fieldProps.input.onChange(value);
                                }}

                            />
                        </>
                    );
                }}
            </PField>
        </InputBox>
    );
}
